import { siteThemeAtom } from "@/config.ts";
import { addThemeListener } from "@/modules/theme/allThemes.ts";
import { getTheme } from "@/modules/theme/getTheme.ts";
import { atomWithRefresh } from "jotai/utils";
import { getDefaultStore } from "jotai/vanilla";

console.debug("Loading theme store...");

export const themeAtom = atomWithRefresh((get) => getTheme(get(siteThemeAtom)));

function forceRefreshThemeAtom() {
    console.debug("Forcing refresh of theme atom");
    getDefaultStore().set(themeAtom);
}

import.meta.hot?.dispose(addThemeListener(forceRefreshThemeAtom));
